// src/components/complaints/ComplaintList.js
import React from 'react';
import ComplaintCard from './ComplaintCard';

function ComplaintList({ complaints, loading, onViewDetails, isAdmin }) {
  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px', color: '#666' }}>
        Loading complaints...
      </div>
    );
  }

  if (complaints.length === 0) {
    return (
      <div style={{
        background: 'white',
        padding: '50px',
        borderRadius: '10px',
        textAlign: 'center',
        color: '#666'
      }}>
        <div style={{ fontSize: '48px', marginBottom: '20px' }}>📋</div>
        <p>No complaints found</p>
      </div>
    );
  }

  return (
    <div style={{ display: 'grid', gap: '15px' }}>
      {complaints.map(complaint => (
        <ComplaintCard
          key={complaint.id}
          complaint={complaint}
          onClick={() => onViewDetails(complaint)}
          isAdmin={isAdmin}
        />
      ))}
    </div>
  );
}

export default ComplaintList;